module.exports = __webpack_public_path__ + "img/liberia.2b40c813.svg";